module.exports = __webpack_public_path__ + "static/media/Concierge_Sample_File.a3ec3f03.csv";